import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import HeaderBar from 'components/header_bar';
import { GraphOutlineIcon, FaqIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import { Outlet } from 'react-router-dom';

const Wrapper = styled.div`

`;

const Content = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props => props.padding};
`;

@observer
class Stories extends React.Component {

  constructor(props) {
    super(props);
    AppUI.createEvent('stories - view page');
  }

  render() {
    return (
      <Wrapper>
        <HeaderBar
          title={AppUI.routeStore.routeName === 'stories.show' ? `VIEW ALL ${AppUI.targetLanguageName} STORIES` : `${AppUI.targetLanguageName} STORIES`}
          titleRoute='stories.home'
          pageInfo={[
            {
              route: 'stories.progress',
              current: 'Progress',
            },
          ]}
          icons={[
            {
              icon: <FaqIcon />,
              tooltipText: 'Help Center',
              iconRoute: 'faq_categories.show',
              iconParams: {faqCategoryId: 'e548f1aa-5193-432b-bff4-b9342ea1434c'},
            },
            {
              icon: <GraphOutlineIcon />,
              tooltipText: 'View Progress',
              iconRoute: 'stories.progress',
              breadcrumb: 'Progress',
            },
          ]}
        />
        <Content>
          <Outlet />
        </Content>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Stories);
